module.exports = "https://static.wanderu.com/static/media/es.039cad8d.svg";